export const isLocalExperimentMode = () => {
  if (process.env.NODE_ENV !== "production") return true;
  if (process.env.REACT_APP_FIREBASE_ENV === "development") return true;

  if (typeof window !== "undefined") {
    const host = String(window.location?.hostname || "").toLowerCase();
    if (host === "localhost" || host === "127.0.0.1") return true;
  }

  return false;
};
